import React from 'react'
import { useState, useEffect } from 'react';
import axios from 'axios';
import HouseRaceTile from './HouseRaceTile';

function HouseStateTile({ state, year }) {

    const [houseDisctricts, setHouseDisctricts] = useState([]);
    const getHouseDisctricts = async () => {
        axios.get("/api/v1/congress/houseRacesDistricts/" + state + "/" + year)
            .then((result) => {
                setHouseDisctricts(result.data);
            })
            .catch((err) => console.log(err));

    };
    useEffect(() => {
        getHouseDisctricts();
    }, []);


    return (
        <div className="thick-border">
            <div className="content-image">
                <center>
                    <div>{state}</div>
                    <img src={"/graphics/flags/Flag_of_" + state.replace(' ', '_') + ".svg"} alt={state} />
                </center>
            </div>
            <div >
                {houseDisctricts.map((district, index) => (
                    <HouseRaceTile state={state} district={district} year='2026' key={index} />
                ))}
            </div>
        </div>
    )
}

export default HouseStateTile

